import styled from "styled-components";

export const DiscountIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
`;

export const ModalContent = styled.div`
  font-family: "Poppins", sans-serif;

  p {
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.14px;
  }

  strong {
    font-weight: 600;
  }

  /* Ensure all table content is left-aligned */
  table {
    th, td {
      text-align: left !important;
    }
    
    /* Align the last column (actions) to the right */
    th:last-child,
    td:last-child {
      text-align: right !important;
    }
  }
`;
